<template>
  <div class="screen-layout">
    <!-- 数据布局 -->
    <template v-if="layoutStyle === LAYOUT_TYPE.DATA">
      <hst-share :shareDataMedia="shareData" />
    </template>
    <!-- 视频布局 -->
    <template v-if="layoutStyle === LAYOUT_TYPE.VIDEO">
      <!-- 有视频流 -->
      <template v-if="showMedia">
        <!-- 视频窗口布局 -->
        <!-- <div class="screen-container" v-if="mediaLayout == 1">
            <picture-in-picture ref="pips" :videoDatas="videoDatas" :shareData="presentShareData"></picture-in-picture>
          </div>
          <div class="screen-container" v-if="mediaLayout == 2"> -->
        <focus-layout :videoDatas="videoDatas" :shareData="{}" />
        <!-- </div> -->
      </template>
      <!-- 没有推流 -->
      <template v-else>
        <div class="no-screen no-select">
          <div class="welcome">欢迎使用好视通</div>
          <div class="wait">会议暂时无人打开视频，请耐心等待。</div>
        </div>
      </template>
    </template>
    <!-- 数据 + 视频布局 -->
    <template v-if="layoutStyle === LAYOUT_TYPE.DATA_VIDEO">
      <div class="mix-wrapper">
        <div class="data">
          <hst-share :shareDataMedia="shareData" />
        </div>
        <div class="video" ref="videoList">
          <div
            class="video-item"
            ref="videoItem"
            v-for="item in layoutWindows"
            :key="`${item.userId}_${item.mediaId}`"
          >
            <div v-if="item.isBlank">
              <layout-video-icon />
            </div>
            <hst-video
              v-else
              :user="item"
              :isBig="false"
              :videoSize="videoSize"
            />
          </div>
        </div>
      </div>
    </template>
    <!-- 最大化某个视频 -->
    <div class="max-video" v-if="maxVideo">
      <hst-video
        :user="maxVideo"
        :isBig="false"
        :videoSize="maxVideoSize"
        video-fit="cover"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import clonedeep from "lodash.clonedeep";
import focusLayout from "@/components/screenLayout/focusLayout"; // 焦点布局
import hstVideo from "@/components/hstMedia/hstVideo";
import HstShare from "./HstShare";
import { layoutVideoIcon } from "@/core/icons";
import { LAYOUT_TYPE } from "@/utils/constants";

export default {
  name: "ScreenLayout",
  components: { focusLayout, hstVideo, HstShare, layoutVideoIcon },
  props: {
    layoutType: {
      type: Number,
      default: LAYOUT_TYPE.DATA,
    },
    showMedia: {
      type: Boolean,
      default: false,
    },
    videoDatas: {
      type: Array,
      default: () => [],
    },
    shareLayoutData: {
      type: Object,
      default: () => {},
    },
    // shareData: {
    //   type: Object,
    //   default: () => {}
    // }
  },
  data() {
    return {
      LAYOUT_TYPE,
      shareData: {},
      videoSize: {
        leftBlack: false,
        videoWidth: 0,
        maxIconWidth: 200,
      },
      maxVideoSize: {
        leftBlack: false,
        videoWidth: "100%",
        maxIconWidth: 200,
      },
    };
  },
  computed: {
    maxVideo() {
      return this.$store.state.medias.maxVideo;
    },
    layoutWindows() {
      let layoutWindows = clonedeep(this.videoDatas);
      const videoLength = this.videoDatas.length;
      // 右侧视频区域限制了固定四个视频窗口
      if (videoLength < 4) {
        for (let i = 0; i < 4 - videoLength; i++) {
          layoutWindows = [
            ...layoutWindows,
            {
              userId: i,
              mediaId: i,
              isBlank: true,
            },
          ];
        }
      } else {
        layoutWindows = layoutWindows.slice(0, 4);
      }
      return layoutWindows;
    },
    layoutStyle() {
      return this.layoutType;
    },
  },
  mounted() {
    this.setVideoWindowSize();
    window.addEventListener("resize", this.setVideoWindowSize);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("resize", this.setVideoWindowSize);
    });
  },
  methods: {
    ...mapMutations(["SET_MAX_VIDEO"]),
    // 动态设置窗口大小
    setVideoWindowSize() {
      const { videoList } = this.$refs;
      if (videoList) {
        videoList.style.width = videoList.offsetHeight / 3 + "px";
      }
    },
    initShareData() {
      this.shareData = this.shareLayoutData;
    },
  },
  watch: {
    layoutType(value) {
      this.SET_MAX_VIDEO(undefined);
      if (value === LAYOUT_TYPE.DATA_VIDEO) {
        this.$nextTick(this.setVideoWindowSize);
      }
    },
    shareLayoutData: {
      handler() {
        this.initShareData();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/utils/utils.less";
.screen-layout {
  width: 100%;
  height: 100%;
  position: relative;
  .no-screen {
    .centerAbs();
    padding-top: 210px;
    width: 260px;
    margin: 0 auto;
    text-align: center;
    box-sizing: border-box;
    background: url("~@/assets/img/extendscreen.png") no-repeat center 10px;
    background-size: 180px 180px;
    .welcome {
      color: #bac7da;
      line-height: 1.5;
      font-size: 24px;
    }
    .wait {
      color: #767a82;
    }
  }
  .max-video {
    background: #272829;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
  }
  .mix-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    .data {
      height: 100%;
      flex: 1;
      background: #e3e7f1;
      position: relative;
    }
    .video {
      height: 100%;
      display: flex;
      flex-direction: column;
      .video-item {
        width: 100%;
        height: 25%;
        background: #232425;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #000000;
        &:not(:first-child) {
          border-top: 1px solid #000000;
        }
      }
    }
  }
}
</style>
